import { render } from "./HFamount.vue?vue&type=template&id=1bafeba4&scoped=true"
import script from "./HFamount.vue?vue&type=script&lang=js"
export * from "./HFamount.vue?vue&type=script&lang=js"

import "./HFamount.vue?vue&type=style&index=0&id=1bafeba4&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bafeba4"]])

export default __exports__